import React from "react";
import { FixedTop } from "@al/akui-mobile";
import cls from "classnames";

import { Props as ShareType } from "~/components/basic/WebShare/meta";

import logo from "./images/logo.png";
import styles from "./index.scss";

type Props = {
  className?: string;
  bottom?: React.ReactNode;
  height?: string;
  headerMainRef?: React.RefObject<HTMLDivElement>;
  // 用来判断搜索按钮是否需要动画
  isHome?: boolean;
  shareInfo?: ShareType;
  isHiddenLogin?: boolean;
  content?: React.ReactNode;
  onMenuItemClick?: (key?: string) => void;
};

const HeaderComponent = (props: Props): JSX.Element => {
  return (
    <FixedTop height={props.height || "0.56rem"} fixedClassName={styles.fixed_wrap}>
      <div className={cls(styles.wrap, props?.className)}>
        <img className={styles.logo} src={logo} />
      </div>
      {props.bottom}
    </FixedTop>
  );
};

export default HeaderComponent;
